// extracted by mini-css-extract-plugin
export var backgroundImage = "ChallengeSection-module--backgroundImage--415fc";
export var content = "ChallengeSection-module--content--4b973";
export var cta = "ChallengeSection-module--cta--5c7dc";
export var info = "ChallengeSection-module--info--5e491";
export var title = "ChallengeSection-module--title--4b2c8";
export var wrapper = "ChallengeSection-module--wrapper--cc829";